
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/pennsylvania",
      function () {
        return require("private-next-pages/medical-card/pennsylvania.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/pennsylvania"])
      });
    }
  